import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchReports, requestReport } from '../../services/api/reportsService';

export const loadReports = createAsyncThunk('reports/load', async () => fetchReports());
export const createReport = createAsyncThunk('reports/create', async (payload) => requestReport(payload));

const reportsSlice = createSlice({
  name: 'reports',
  initialState: { loadStatus: 'idle', createStatus: 'idle', loadError: null, createError: null, items: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadReports.pending, (state) => { state.loadStatus = 'loading'; state.loadError = null; })
      .addCase(loadReports.fulfilled, (state, action) => { state.loadStatus = 'succeeded'; state.items = action.payload; })
      .addCase(loadReports.rejected, (state, action) => { state.loadStatus = 'failed'; state.loadError = action.error.message; })
      .addCase(createReport.pending, (state) => { state.createStatus = 'creating'; state.createError = null; })
      .addCase(createReport.fulfilled, (state, action) => { state.createStatus = 'succeeded'; state.items.unshift(action.payload); })
      .addCase(createReport.rejected, (state, action) => { state.createStatus = 'failed'; state.createError = action.error.message; });
  }
});

export default reportsSlice.reducer;
